<template>
  <CardModule untitle>
    <v-row>
      <v-col cols="12" md="10">
        <v-chip-group
          :column="mdAndUp"
          :show-arrows="!mdAndUp"
          v-model="tab"
          @change="onTabChange(tab)"
          active-class="primary--text"
          mandatory
        >
          <v-chip
            v-for="(item, index) in tabInfo"
            :key="index"
            class="custom-chip mr-4"
            color="#E9E8ED"
            :small="!mdAndUp"
            active-class="primary active-class"
          >
            {{ item.title }}
          </v-chip>
        </v-chip-group>
      </v-col>

      <v-col cols="12" md="2" class="d-flex flex-row justify-end pr-6 pr-md-3">
        <v-btn
          class="rounded-xxl"
          v-for="(act, index) in actions"
          :key="index"
          @click="act.action()"
          :class="index == 0 ? 'button' : 'button btn-right'"
          :loading="act.id === 'CSV' ? primaryLoading : secondaryLoading"
          :disabled="act.id == 'NEW' ? disableActions : false"
        >
          {{ act.name }}
          <v-icon>
            {{ act.icon }}
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-tabs-items v-model="tab" touchless class="pa-3 pa-md-0">
      <v-tab-item v-for="(item, index) in tabInfo" :key="index">
        <component
          v-bind="{ ...$props }"
          :descricao="descProduto"
          :is="item.component"
        ></component>
      </v-tab-item>
    </v-tabs-items>
  </CardModule>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import displayHelpers from "@/mixins/breakpoints.mixins";
import CardModule from "@/components/cards/CardModule.vue";

import General from "@/components/relatorios/General.vue";
import SalesByDay from "@/components/relatorios/SalesByDay.vue";
import SalesByChannel from "@/components/relatorios/SalesByChannel.vue";
import Cancellation from "@/components/relatorios/Cancellation.vue";
import SalesByPointOfSale from "@/components/relatorios/SalesByPointOfSale.vue";
import Affiliate from "@/components/relatorios/Affiliate.vue";

export default {
  name: "ReportDash",
  components: { CardModule },
  mixins: [displayHelpers],
  props: {
    actions: {
      type: Array,
      default: () => [],
    },
    primaryLoading: {
      type: Boolean,
      default: false,
    },
    secondaryLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tab: 0,
    };
  },
  computed: {
    ...mapGetters([
      "dashEvent",
      "reportsFilter",
      "storeSequencial",
      "descProduto",
    ]),
    tabInfo() {
      return [
        {
          title: this.$t("reports.general-sales.title"),
          component: General,
        },
        {
          title: this.$t("reports.sales-by-day.title"),
          component: SalesByDay,
        },
        {
          title: this.$t("reports.sales-by-affiliate.title"),
          component: Affiliate,
        },
        {
          title: this.$t("reports.channel-sales.title"),
          component: SalesByChannel,
        },
        {
          title: this.$t("reports.point-of-sale.title"),
          component: SalesByPointOfSale,
        },
        {
          title: this.$t("reports.cancellation.title"),
          component: Cancellation,
        },
      ];
    },
  },
  methods: {
    ...mapActions([]),
    onTabChange(index) {
      this.$emit("tab-changed", index);
    },
  },
};
</script>

<style scoped>
.custom-chip {
  font-size: 1rem;
  transition: none;
}

.custom-chip:hover {
  box-shadow: inset 0px 0px 0px 1px #cbcbcb;
}

.active-class {
  color: #f2f2f2 !important;
}
.active-class:hover {
  box-shadow: none;
}
</style>
